import { styled } from "../../theme";
import { lightenColor } from "../../utils";

export const NavigationButton = styled.button<{ reverseDirection: boolean }>`
  border: solid 1px;
  border-color: ${({ theme }) => theme.color.primary};
  background-color: ${({ theme }) => theme.color.primary};
  background-image: url(${({ theme }) => theme.icons.navigationArrow});
  background-position: center;
  background-size: 90%;
  background-repeat: no-repeat;
  padding: 0.5em 1em 0.5em 1em;
  width: 4em;
  height: 4em;
  align-self: center;
  transform: ${(props) => (props.reverseDirection ? "scaleX(-1)" : "scaleX(1)")};
  border-radius: 0.25em;
  transition: all 0.2s;
  cursor: pointer;
  box-sizing: border-box;
  :hover {
    border-color: ${({ theme }) => lightenColor(theme.color.primary, 5)};
    background-color: ${({ theme }) => lightenColor(theme.color.primary, 5)};
    box-shadow: 0px 0px 7px 3px rgba(0, 0, 0, 0.2);
  }
  :focus {
    border: none;
    outline: none;
  }
  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    position: fixed;
    bottom: 1em;
    right: ${(props) => (props.reverseDirection ? "20%" : "initial")};
    left: ${(props) => (props.reverseDirection ? "initial" : "20%")};
  }
`;
